const chat = [
  {
      id: 1,
      name: 'chat.tabs.chats.recent.userslist.user1.name',
      profilePicture: 'assets/images/users/avatar-2.jpg',
      status: 'online',
      lastMessage: 'chat.tabs.chats.recent.userslist.user1.message',
      time: 'chat.tabs.chats.recent.userslist.user1.time',
      isActive: true,
      messages: [
        {
          id: 1,
          message: 'chat.messages.1.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.1.time'
        },
        {
            id: 2,
            message: 'chat.messages.2.message',
            name: 'chat.messages.2.name',
            profile: 'assets/images/users/avatar-1.jpg',
            time: 'chat.messages.2.time',
            align: 'right'
        },
        {
            isToday: true
        },
        {
            id: 3,
            message: 'chat.messages.3.message',
            message2: 'chat.messages.3.message2',
            name: 'chat.messages.3.name',
            profile: 'assets/images/users/avatar-4.jpg',
            time: 'chat.messages.3.time',
        },
        {
            id: 4,
            message: 'chat.messages.4.message',
            name: 'chat.messages.4.name',
            profile: 'assets/images/users/avatar-1.jpg',
            time: 'chat.messages.4.time',
            align: 'right'
        },
        {
            id: 5,
            name: 'chat.messages.5.name',
            profile: 'assets/images/users/avatar-1.jpg',
            time: 'chat.messages.5.time',
            isimage: true,
            imageContent: [
              {id:'1',src:'assets/images/small/img-1.jpg',caption:'Image 4 caption here',thumb:'assets/images/small/img-1.jpg'},
            ]
        },
        {
            id: 6,
            name: 'chat.messages.6.name',
            profile: 'assets/images/users/avatar-1.jpg',
            time: 'chat.messages.6.time',
            align: 'right',
            isfile: true,
            fileContent: 'admin_v1.0.zip',
            fileSize: '12.5 MB'
        },
        {
          id: 1,
          message: '👍',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.1.time',
          replayName: "You",
          replaymsg: `chat.messages.1.message`,
          align: 'right',
        },
      ]
  },
  {
      id: 2,
      name: 'chat.tabs.chats.recent.userslist.user2.name',
      profilePicture: 'assets/images/users/avatar-3.jpg',
      status: 'away',
      unRead: '02',
      lastMessage: 'chat.tabs.chats.recent.userslist.user2.message',
      time: 'chat.tabs.chats.recent.userslist.user2.time',
      messages: [
        {
          id: 1,
          message: 'chat.messages.8.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.1.time',
          align: 'right'
        },
        {
          id: 2,
          name: 'chat.messages.5.name',
          profile: 'assets/images/users/avatar-1.jpg',
          time: 'chat.messages.5.time',
          isimage: true,
          imageContent: [
            {id:'4',src:'assets/images/small/img-4.jpg',caption:'Image 4 caption here',thumb:'assets/images/small/img-4.jpg'},
            {id:'5',src:'assets/images/small/img-5.jpg',caption:'Image 5 caption here',thumb:'assets/images/small/img-5.jpg'},
          ],
          imageNo: ['4','5']
        },
      ]
  },
  {
      id: 3,
      name: 'chat.tabs.chats.recent.userslist.user3.name',
      lastMessage: 'chat.tabs.chats.recent.userslist.user3.message',
      time: 'chat.tabs.chats.recent.userslist.user3.time',
      messages: [
        {
          id: 1,
          message: 'chat.messages.9.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.1.time'
        },
        {
          id: 2,
          name: 'chat.messages.5.name',
          profile: 'assets/images/users/avatar-1.jpg',
          time: 'chat.messages.5.time',
          isimage: true,
          imageContent: [
            {id:'4',src:'assets/images/small/img-4.jpg',caption:'Image 4 caption here',thumb:'assets/images/small/img-4.jpg'},
            {id:'6',src:'assets/images/small/img-6.jpg',caption:'Image 6 caption here',thumb:'assets/images/small/img-6.jpg'},
          ]
        },
        {
          id: 3,
          message: 'chat.messages.10.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.10.time',
          align: 'right'
        },
        {
          id: 34,
          message: 'chat.messages.11.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.11.time'
        },
      ]
  },
  {
      id: 4,
      name: 'chat.tabs.chats.recent.userslist.user4.name',
      profilePicture: 'assets/images/users/avatar-4.jpg',
      status: 'online',
      lastMessage: 'chat.tabs.chats.recent.userslist.user4.message',
      time: 'chat.tabs.chats.recent.userslist.user4.time',
      messages: [
        {
          id: 1,
          message: 'chat.messages.1.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.1.time'
        },
        {
            id: 2,
            message: 'chat.messages.2.message',
            name: 'chat.messages.2.name',
            profile: 'assets/images/users/avatar-1.jpg',
            time: 'chat.messages.2.time',
            align: 'right'
        },
        {
            isToday: true
        },
        {
            id: 3,
            message: 'chat.messages.3.message',
            message2: 'chat.messages.3.message2',
            name: 'chat.messages.3.name',
            profile: 'assets/images/users/avatar-4.jpg',
            time: 'chat.messages.3.time',
        },
        {
            id: 4,
            message: 'chat.messages.4.message',
            name: 'chat.messages.4.name',
            profile: 'assets/images/users/avatar-1.jpg',
            time: 'chat.messages.4.time',
            align: 'right'
        },
        {
            id: 5,
            name: 'chat.messages.5.name',
            profile: 'assets/images/users/avatar-1.jpg',
            time: 'chat.messages.5.time',
            isimage: true,
            imageContent: [
              {id:'1',src:'assets/images/small/img-1.jpg',caption:'Image 1 caption here',thumb:'assets/images/small/img-1.jpg'},
              {id:'2',src:'assets/images/small/img-2.jpg',caption:'Image 2 caption here',thumb:'assets/images/small/img-2.jpg'}
            ]
        },
        {
            id: 6,
            name: 'chat.messages.6.name',
            profile: 'assets/images/users/avatar-1.jpg',
            time: 'chat.messages.6.time',
            align: 'right',
            isfile: true,
            fileContent: 'admin_v1.0.zip',
            fileSize: '12.5 MB'
        }
      ]
  },
  {
      id: 5,
      name: 'chat.tabs.chats.recent.userslist.user5.name',
      unRead: '01',
      lastMessage: 'chat.tabs.chats.recent.userslist.user5.message',
      time: 'chat.tabs.chats.recent.userslist.user5.time',
      messages: [
        {
          id: 1,
          message: 'chat.messages.9.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.9.time'
        },
        {
          isToday: true
        },
        {
          id: 2,
          name: 'chat.messages.5.name',
          profile: 'assets/images/users/avatar-1.jpg',
          time: 'chat.messages.5.time',
          isimage: true,
          imageContent: [
            {id:'2',src:'assets/images/small/img-2.jpg',caption:'Image 2 caption here',thumb:'assets/images/small/img-2.jpg'},
          ]
        },
        {
          id: 3,
          name: 'chat.messages.6.name',
          profile: 'assets/images/users/avatar-1.jpg',
          time: 'chat.messages.6.time',
          align: 'right',
          isfile: true,
          fileContent: 'Minible-Vertical.zip',
          fileSize: '12.5 MB'
        },
        {
          id: 4,
          message: 'chat.messages.12.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.12.time',
          align: 'right'
        },
        {
          id: 5,
          message: 'chat.messages.10.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.10.time'
        },
      ]
  },
  {
      id: 6,
      name: 'chat.tabs.chats.recent.userslist.user6.name',
      profilePicture: 'assets/images/users/avatar-6.jpg',
      status: 'away',
      lastMessage: 'chat.tabs.chats.recent.userslist.user6.message',
      time: 'chat.tabs.chats.recent.userslist.user6.time',
      messages: [
        {
            id: 1,
            name: 'chat.messages.6.name',
            profile: 'assets/images/users/avatar-1.jpg',
            time: 'chat.messages.6.time',
            isfile: true,
            fileContent: 'Minible-Vertical.zip',
            fileSize: '12.5 MB',
        },
        {
          id: 2,
          message: 'chat.messages.13.message',
          name: 'chat.messages.2.name',
          profile: 'assets/images/users/avatar-1.jpg',
          time: 'chat.messages.13.time',
          align: 'right'
        },
      ]
  },
  {
      id: 7,
      name: 'chat.tabs.chats.recent.userslist.user7.name',
      status: 'online',
      isTyping: true,
      time: '04:56 PM',
      messages: [
        {
          id: 1,
          message: 'chat.messages.14.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.14.time'
        },
        {
          id: 2,
          message: 'chat.messages.15.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.15.time',
          align: 'right'
        },
      ]
  },
  {
      id: 8,
      name: 'chat.tabs.chats.recent.userslist.user8.name',
      status: 'online',
      lastMessage: 'chat.tabs.chats.recent.userslist.user8.message',
      time: 'chat.tabs.chats.recent.userslist.user8.time',
      messages: [
        {
          id: 1,
          message: 'chat.messages.16.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.16.time'
        },
        {
          id: 2,
          name: 'chat.messages.5.name',
          profile: 'assets/images/users/avatar-1.jpg',
          time: 'chat.messages.5.time',
          isimage: true,
          imageContent: [
            {id:'4',src:'assets/images/small/img-4.jpg',caption:'Image 4 caption here',thumb:'assets/images/small/img-4.jpg'},
            {id:'2',src:'assets/images/small/img-2.jpg',caption:'Image 2 caption here',thumb:'assets/images/small/img-2.jpg'},
          ]
        },
        {
          id: 3,
          message: 'chat.messages.17.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.17.time'
        },
        {
          id: 4,
          message: 'chat.messages.18.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.18.time',
          align: 'right'
        },
      ]
  },
  {
      id: 9,
      name: 'chat.tabs.chats.recent.userslist.user9.name',
      profilePicture: 'assets/images/users/avatar-7.jpg',
      status: 'away',
      lastMessage: 'chat.tabs.chats.recent.userslist.user9.message',
      time: 'chat.tabs.chats.recent.userslist.user9.time',
      messages: [
        {
          id: 1,
          message: 'chat.messages.16.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.16.time'
        },
        {
          id: 2,
          name: 'chat.messages.5.name',
          profile: 'assets/images/users/avatar-1.jpg',
          time: 'chat.messages.5.time',
          isimage: true,
          imageContent: [
            {id:'4',src:'assets/images/small/img-2.jpg',caption:'Image 4 caption here',thumb:'assets/images/small/img-4.jpg'},
            {id:'1',src:'assets/images/small/img-2.jpg',caption:'Image 2 caption here',thumb:'assets/images/small/img-2.jpg'}
          ],
          align: 'right'
        },
        {
          id: 3,
          message: 'chat.messages.17.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.17.time',
          align: 'right'
        },
        {
          id: 4,
          message: 'chat.messages.19.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.19.time',
        },
      ]
  },
  {
      id: 10,
      name: 'chat.tabs.chats.recent.userslist.user10.name',
      status: 'online',
      lastMessage: 'chat.tabs.chats.recent.userslist.user10.message',
      time: 'chat.tabs.chats.recent.userslist.user10.time',
      messages: [
        {
          id: 1,
          message: 'chat.messages.20.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.20.time'
        },
        {
          id: 2,
          message: 'chat.messages.21.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.21.time',
          align: 'right'
        },
        {
          id: 3,
          message: 'chat.messages.22.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.22.time'
        },
        {
          id: 4,
          message: 'chat.messages.23.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.23.time'
        },
        {
          id: 5,
          message: 'chat.messages.24.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.24.time'
        },
      ]
  },
  {
      id: 11,
      name: 'chat.tabs.chats.recent.userslist.user11.name',
      profilePicture: 'assets/images/users/avatar-8.jpg',
      status: 'away',
      lastMessage: 'chat.tabs.chats.recent.userslist.user11.message',
      time: 'chat.tabs.chats.recent.userslist.user11.time',
      messages: [
        {
          id: 1,
          message: 'chat.messages.14.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.14.time',
          align: 'right'
        },
        {
          id: 2,
          message: 'chat.messages.25.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.25.time',
          align: 'right'
        },
        {
          id: 3,
          name: 'chat.messages.5.name',
          profile: 'assets/images/users/avatar-1.jpg',
          time: 'chat.messages.5.time',
          isimage: true,
          imageContent: [
            {id:'3',src:'assets/images/small/img-3.jpg',caption:'Image 3 caption here',thumb:'assets/images/small/img-3.jpg'}
          ]
        }
      ]
  },
  {
      id: 12,
      name: 'chat.tabs.chats.recent.userslist.user12.name',
      status: 'online',
      lastMessage: 'chat.tabs.chats.recent.userslist.user12.message',
      time: 'chat.tabs.chats.recent.userslist.user12.time',
      messages: [
        {
          id: 1,
          message: 'chat.messages.26.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.26.time',
          align: 'right'
        },
        {
          id: 2,
          name: 'chat.messages.5.name',
          profile: 'assets/images/users/avatar-1.jpg',
          time: 'chat.messages.5.time',
          isimage: true,
          imageContent: [
            {id:'3',src:'assets/images/small/img-3.jpg',caption:'Image 3 caption here',thumb:'assets/images/small/img-3.jpg'},
          ]
        },
        {
          id: 3,
          message: 'chat.messages.27.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.27.time',
          align: 'right'
        }
      ]
  },
]

const groups = [
  {
      id: 1, name: 'chat.tabs.groups.list.general',
      messages: [
        {
          id: 1,
          message: 'chat.messages.26.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.26.time',
          align: 'right'
        },
        {
          id: 2,
          name: 'chat.messages.5.name',
          profile: 'assets/images/users/avatar-1.jpg',
          time: 'chat.messages.5.time',
          isimage: true,
          imageContent: [
              {id:'3',src:'assets/images/small/img-3.jpg',caption:'Image 3 caption here',thumb:'assets/images/small/img-3.jpg'},
          ]
        },
        {
          id: 3,
          message: 'chat.messages.27.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.27.time',
          align: 'right'
        }
      ]
  },
  {
      id: 2, name: 'chat.tabs.groups.list.reporting',
      unread: '+23',
      messages: [
        {
          id: 1,
          message: 'chat.messages.9.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.9.time'
        },
        {
          isToday: true
        },
        {
          id: 2,
          name: 'chat.messages.5.name',
          profile: 'assets/images/users/avatar-1.jpg',
          time: 'chat.messages.5.time',
          isimage: true,
          imageContent: [
            {id:'2',src:'assets/images/small/img-2.jpg',caption:'Image 2 caption here',thumb:'assets/images/small/img-2.jpg'},
          ]
        },
        {
          id: 3,
          name: 'chat.messages.6.name',
          profile: 'assets/images/users/avatar-1.jpg',
          time: 'chat.messages.6.time',
          align: 'right',
          isfile: true,
          fileContent: 'Minible-Vertical.zip',
          fileSize: '12.5 MB'
        },
        {
          id: 4,
          message: 'chat.messages.12.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.12.time',
          align: 'right'
        },
        {
          id: 5,
          message: 'chat.messages.10.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.10.time'
        },
      ]
  },
  {
      id: 3, name: 'chat.tabs.groups.list.designers',
      messages: [
        {
          id: 1,
          message: 'chat.messages.14.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.14.time'
        },
        {
          id: 2,
          message: 'chat.messages.15.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.15.time',
          align: 'right'
        },
      ]
  },
  {
      id: 4, name: 'chat.tabs.groups.list.developer',
      unread: 'New',
      messages: [
        {
          id: 1,
          message: 'chat.messages.16.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.16.time'
        },
        {
          id: 2,
          name: 'chat.messages.5.name',
          profile: 'assets/images/users/avatar-1.jpg',
          time: 'chat.messages.5.time',
          isimage: true,
          imageContent: [
            {id:'4',src:'assets/images/small/img-4.jpg',caption:'Image 4 caption here',thumb:'assets/images/small/img-4.jpg'},
            {id:'2',src:'assets/images/small/img-2.jpg',caption:'Image 2 caption here',thumb:'assets/images/small/img-2.jpg'}
          ],
          align: 'right'
        },
        {
          id: 3,
          message: 'chat.messages.17.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.17.time',
          align: 'right'
        },
        {
          id: 4,
          message: 'chat.messages.19.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.19.time',
        },
      ]
  },
  {
      id: 5, name: 'chat.tabs.groups.list.projectalpha',
      messages: [
        {
          id: 1,
          message: 'chat.messages.9.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.1.time'
        },
        {
          id: 2,
          name: 'chat.messages.5.name',
          profile: 'assets/images/users/avatar-1.jpg',
          time: 'chat.messages.5.time',
          isimage: true,
          imageContent: [
            {id:'4',src:'assets/images/small/img-4.jpg',caption:'Image 4 caption here',thumb:'assets/images/small/img-4.jpg'},
            {id:'6',src:'assets/images/small/img-6.jpg',caption:'Image 6 caption here',thumb:'assets/images/small/img-6.jpg'}
          ]
        },
        {
          id: 3,
          message: 'chat.messages.10.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.10.time',
          align: 'right'
        },
        {
          id: 34,
          message: 'chat.messages.11.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.11.time'
        },
      ]
  },
  {
      id: 6, name: 'chat.tabs.groups.list.snacks',
      messages: [
        {
          id: 1,
          message: 'chat.messages.8.message',
          name: 'chat.messages.1.name',
          profile: 'assets/images/users/avatar-4.jpg',
          time: 'chat.messages.1.time',
          align: 'right'
        },
        {
          id: 2,
          name: 'chat.messages.5.name',
          profile: 'assets/images/users/avatar-1.jpg',
          time: 'chat.messages.5.time',
          isimage: true,
          imageContent: [
            {id:'4',src:'assets/images/small/img-4.jpg',caption:'Image 4 caption here',thumb:'assets/images/small/img-4.jpg'},
            {id:'5',src:'assets/images/small/img-5.jpg',caption:'Image 5 caption here',thumb:'assets/images/small/img-5.jpg'}
          ]
        },
      ]
  }
];


export { chat, groups };
